/*jslint browser: true */
/*global window */

(function($){

})(jQuery);